import moment from 'moment';

export default function getTime(startTime, endTime) {
    let emptyVal = '';
    if (startTime != null && endTime != null) {
        let firstTime = moment(startTime).format('hh:mm A');
        let secondTime = moment(endTime).format('hh:mm A');
        let fullTime = firstTime + " - " + secondTime;
        return fullTime;
    }
    return emptyVal;
}